import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

import { useMutation, useQueryClient } from '@tanstack/react-query'

const handleDeleteReport = async ({
  reportIds,
  companyId,
}: {
  reportIds: string
  companyId: string
}) => {
  try {
    const response = await axios.delete(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/content-gap/${reportIds}`
    )

    return response.data
  } catch (error) {
    return extract.error(error)
  }
}

export const useDeleteReport = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      reportIds,
      companyId,
    }: {
      reportIds: string
      companyId: string
    }) => handleDeleteReport({ reportIds, companyId }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['content-gap-url-refresh-reports'],
      })
    },
  })
}
